import { useIsMobile } from "@/lib/hooks/use-mobile";
import { ServicesPageDesktop } from "../components/layouts/services-page-desktop";
import { ServicesPageMobile } from "../components/layouts/services-page-mobile";
import { ServicesProvider } from "../context/services-context";

function ServicesPageContent() {
  const isMobile = useIsMobile();

  // Route to appropriate layout based on device
  if (isMobile) {
    return <ServicesPageMobile />;
  }

  return <ServicesPageDesktop />;
}

export function ServicesPage() {
  return (
    <ServicesProvider>
      <ServicesPageContent />
    </ServicesProvider>
  );
}
